// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__kou5W","error":"Textarea_error__16dLC","readonly":"Textarea_readonly__1piu8","disabled":"Textarea_disabled__2hBA6"};